"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKOUT_AVAILABILITY_STATUSES = void 0;
exports.CHECKOUT_AVAILABILITY_STATUSES = [
    'enabled',
    'disabled',
    'paused',
];
//# sourceMappingURL=types.js.map